


// //=============================================================

// /// src/components/landing/ContactSection.tsx
// import React, { useState } from "react";
// import {
//   Phone,
//   MapPin,
//   Instagram,
//   Twitter,
//   Linkedin,
//   Facebook,
//   Send,
//   Loader2,
//   CheckCircle2,
//   LifeBuoy,
//   TrendingUp,
//   Users,
//   Receipt,
//   Megaphone,
//   ExternalLink,
// } from "lucide-react";
// import { submitUserQuery } from "../../services/UserQuery.api";

// const CONTACT_INFO = {
//   phone: "+91 98765 43210",
//   address: "Agra, Uttar Pradesh, India",
// };

// const CONTACT_EMAILS = [
//   {
//     label: "Support",
//     email: "support@adroj.com",
//     blurb: "Account & platform help",
//     icon: LifeBuoy,
//   },
//   {
//     label: "Sales",
//     email: "sales@adroj.com",
//     blurb: "New bookings & pricing",
//     icon: TrendingUp,
//   },
//   {
//     label: "Partnerships",
//     email: "partners@adroj.com",
//     blurb: "Media owners & tie-ups",
//     icon: Users,
//   },
//   {
//     label: "Billing",
//     email: "billing@adroj.com",
//     blurb: "Invoices & payments",
//     icon: Receipt,
//   },
//   {
//     label: "Advertise",
//     email: "advertise@adroj.com",
//     blurb: "Campaign enquiries",
//     icon: Megaphone,
//   },
// ];

// // Opens Gmail's web compose window directly, with the department address
// // already filled into the "To" field, instead of relying on a mailto:
// // handler / default desktop mail client.
// const gmailComposeUrl = (to: string) =>
//   `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(to)}`;

// const SOCIAL_LINKS = [
//   { icon: Instagram, href: "#", label: "Instagram" },
//   { icon: Twitter, href: "#", label: "Twitter" },
//   { icon: Linkedin, href: "#", label: "LinkedIn" },
//   { icon: Facebook, href: "#", label: "Facebook" },
// ];

// type Status = "idle" | "submitting" | "success" | "error";

// export function ContactSection() {
//   const [fullName, setFullName] = useState("");
//   const [email, setEmail] = useState("");
//   const [phone, setPhone] = useState("");
//   const [alternatePhone, setAlternatePhone] = useState("");
//   const [message, setMessage] = useState("");
//   const [status, setStatus] = useState<Status>("idle");
//   const [error, setError] = useState<string | null>(null);

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!fullName.trim() || !email.trim() || !phone.trim() || !message.trim()) return;

//     setStatus("submitting");
//     setError(null);
//     try {
//       await submitUserQuery({
//         fullName: fullName.trim(),
//         email: email.trim(),
//         phone: phone.trim(),
//         alternatePhone: alternatePhone.trim() || undefined,
//         message: message.trim(),
//       });
//       setStatus("success");
//       setFullName("");
//       setEmail("");
//       setPhone("");
//       setAlternatePhone("");
//       setMessage("");
//     } catch (err) {
//       setStatus("error");
//       setError(err instanceof Error ? err.message : "Something went wrong. Please try again.");
//     }
//   };

//   const inputClass =
//     "w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-[#0F172A] placeholder:text-slate-400 focus:border-[#EB4A2D] focus:outline-none focus:ring-2 focus:ring-[#EB4A2D]/15";
//   const labelClass = "mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-slate-500";

//   return (
//     <section id="discuss-campaign" className="bg-[#ced8eb] py-20 my-4">
//       <div className="mx-auto max-w-7xl px-5 sm:px-8">
//         <div className="text-center">
//           <span className="text-[11px] font-semibold uppercase tracking-wider text-[#EB4A2D]">Get in touch</span>
//           <h2 className="font-display mt-3 text-3xl text-[#0F172A] sm:text-4xl">Let&apos;s Discuss Your Campaign</h2>
//           <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-slate-500">
//             Reach the right team directly — every card opens a ready-to-send email in Gmail.
//           </p>
//         </div>

//         {/* Department email cards — visually separated, each opens Gmail compose */}
//         <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
//           {CONTACT_EMAILS.map((c) => (
//             <a
//               key={c.email}
//               href={gmailComposeUrl(c.email)}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="group relative flex flex-col gap-3 rounded-2xl border border-white/60 bg-gradient-to-br from-white via-[#fdf3f0] to-[#eaf4fb] p-5 shadow-[0_16px_30px_-20px_rgba(15,23,42,0.25)] transition-all hover:-translate-y-1 hover:border-[#EB4A2D]/40 hover:from-[#fff1ec] hover:to-[#e4f1fb] hover:shadow-[0_20px_40px_-18px_rgba(235,74,45,0.35)]"
//             >
//               <ExternalLink className="absolute right-4 top-4 h-3.5 w-3.5 text-slate-300 transition-colors group-hover:text-[#EB4A2D]" />
//               <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/80 text-[#EB4A2D] shadow-sm transition-colors group-hover:bg-[#EB4A2D] group-hover:text-white">
//                 <c.icon className="h-5 w-5" />
//               </span>
//               <div>
//                 <p className="text-sm font-semibold text-[#0F172A]">{c.label}</p>
//                 <p className="mt-0.5 text-[11px] text-slate-500">{c.blurb}</p>
//               </div>
//               <p className="mt-auto break-all text-xs font-medium text-slate-600 group-hover:text-[#EB4A2D]">
//                 {c.email}
//               </p>
//             </a>
//           ))}
//         </div>

//         <div className="mt-14 grid gap-12 lg:grid-cols-2 lg:items-center">
//           <div>
//             <div className="space-y-4">
//               <a
//                 href={`tel:${CONTACT_INFO.phone.replace(/\s+/g, "")}`}
//                 className="flex items-center gap-3 text-sm text-slate-600 hover:text-[#0F172A]"
//               >
//                 <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#EB4A2D]/10 text-[#EB4A2D]">
//                   <Phone className="h-4 w-4" />
//                 </span>
//                 {CONTACT_INFO.phone}
//               </a>
//               <div className="flex items-center gap-3 text-sm text-slate-600">
//                 <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#EB4A2D]/10 text-[#EB4A2D]">
//                   <MapPin className="h-4 w-4" />
//                 </span>
//                 {CONTACT_INFO.address}
//               </div>
//             </div>

//             <div className="mt-10">
//               <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Follow us</span>
//               <div className="mt-3 flex items-center gap-2.5">
//                 {SOCIAL_LINKS.map((s) => (
//                   <a
//                     key={s.label}
//                     href={s.href}
//                     aria-label={s.label}
//                     className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition-colors hover:border-slate-300 hover:text-[#0F172A]"
//                   >
//                     <s.icon className="h-4 w-4" />
//                   </a>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_24px_50px_-24px_rgba(15,23,42,0.15)] sm:p-8">
//             <h3 className="text-base font-semibold text-[#0F172A]">Send a Message</h3>

//             {status === "success" ? (
//               <div className="mt-6 flex flex-col items-center gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-5 py-10 text-center">
//                 <CheckCircle2 className="h-8 w-8 text-emerald-500" />
//                 <p className="text-sm text-slate-600">
//                   Thanks — your message has been sent. Our team will get back to you shortly.
//                 </p>
//                 <button
//                   onClick={() => setStatus("idle")}
//                   className="mt-1 text-xs font-semibold text-[#EB4A2D] hover:underline"
//                 >
//                   Send another message
//                 </button>
//               </div>
//             ) : (
//               <form onSubmit={handleSubmit} className="mt-5 space-y-4">
//                 <div>
//                   <label className={labelClass}>Full name *</label>
//                   <input
//                     className={inputClass}
//                     placeholder="Enter your full name"
//                     value={fullName}
//                     onChange={(e) => setFullName(e.target.value)}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className={labelClass}>Email address *</label>
//                   <input
//                     type="email"
//                     className={inputClass}
//                     placeholder="Enter your email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                   />
//                 </div>
//                 <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
//                   <div>
//                     <label className={labelClass}>Phone number *</label>
//                     <input
//                       type="tel"
//                       className={inputClass}
//                       placeholder="Enter your phone number"
//                       value={phone}
//                       onChange={(e) => setPhone(e.target.value)}
//                       required
//                     />
//                   </div>
//                   <div>
//                     <label className={labelClass}>Alternate phone number</label>
//                     <input
//                       type="tel"
//                       className={inputClass}
//                       placeholder="Optional"
//                       value={alternatePhone}
//                       onChange={(e) => setAlternatePhone(e.target.value)}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className={labelClass}>Message *</label>
//                   <textarea
//                     className={`${inputClass} min-h-[110px] resize-none`}
//                     placeholder="Tell us about your advertising needs..."
//                     value={message}
//                     onChange={(e) => setMessage(e.target.value)}
//                     required
//                   />
//                 </div>

//                 {status === "error" && error && (
//                   <p className="text-xs text-red-500">{error}</p>
//                 )}

//                 <button
//                   type="submit"
//                   disabled={status === "submitting"}
//                   className="flex w-full items-center justify-center gap-2 rounded-full bg-[#EB4A2D] px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-500/20 transition-transform hover:scale-[1.01] disabled:opacity-60"
//                 >
//                   {status === "submitting" ? (
//                     <>
//                       <Loader2 className="h-4 w-4 animate-spin" /> Sending...
//                     </>
//                   ) : (
//                     <>
//                       Send Message <Send className="h-4 w-4" />
//                     </>
//                   )}
//                 </button>
//               </form>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

/// src/components/landing/ContactSection.tsx
import React, { useState } from "react";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
  Phone,
  MapPin,
  Instagram,
  Twitter,
  Linkedin,
  Facebook,
  Send,
  Loader2,
  CheckCircle2,
  LifeBuoy,
  TrendingUp,
  Users,
  Receipt,
  Megaphone,
  ArrowUpRight,
} from "lucide-react";
import { submitUserQuery } from "../../services/UserQuery.api";

// reCAPTCHA v3 SITE keys only (public). Secret keys live on the backend.
// TODO: move to .env (REACT_APP_RECAPTCHA_SITE_KEY) later.
const RECAPTCHA_SITE_KEYS = {
  // key "adrojlocal": used for QA (adroj.atplindia.org) and local development
  qa: "6LfARNktAAAAAE_Ps68lK-SQ-HwntspAxf6XWzGB",

  // production (adroj.com)
  production: "6Ldhh9ctAAAAAOgJxQgIM0qKVVjcX7K-0xbT_77d",
};

const PRODUCTION_HOSTS = ["adroj.com", "www.adroj.com"];

const getRecaptchaSiteKey = (): string =>
  PRODUCTION_HOSTS.includes(window.location.hostname)
    ? RECAPTCHA_SITE_KEYS.production
    : RECAPTCHA_SITE_KEYS.qa; // QA and localhost

const RECAPTCHA_SITE_KEY = getRecaptchaSiteKey();

const CONTACT_INFO = {
  phone: "+91 98765 43210",
  address: "Agra, Uttar Pradesh, India",
};

const CONTACT_EMAILS = [
  {
    label: "Support",
    email: "support@adroj.com",
    blurb: "Account & platform help",
    icon: LifeBuoy,
  },
  {
    label: "Sales",
    email: "sales@adroj.com",
    blurb: "New bookings & pricing",
    icon: TrendingUp,
  },
  {
    label: "Partnerships",
    email: "partners@adroj.com",
    blurb: "Media owners & tie-ups",
    icon: Users,
  },
  {
    label: "Billing",
    email: "billing@adroj.com",
    blurb: "Invoices & payments",
    icon: Receipt,
  },
  {
    label: "Advertise",
    email: "advertise@adroj.com",
    blurb: "Campaign enquiries",
    icon: Megaphone,
  },
];

// Opens Gmail's web compose window directly, with the department address
// already filled into the "To" field, instead of relying on a mailto:
// handler / default desktop mail client.
const gmailComposeUrl = (to: string) =>
  `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(to)}`;

const SOCIAL_LINKS = [
  { icon: Instagram, href: "#", label: "Instagram" },
  { icon: Twitter, href: "#", label: "Twitter" },
  { icon: Linkedin, href: "#", label: "LinkedIn" },
  { icon: Facebook, href: "#", label: "Facebook" },
];

type Status = "idle" | "submitting" | "success" | "error";

function ContactSectionContent() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [alternatePhone, setAlternatePhone] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!fullName.trim() || !email.trim() || !phone.trim() || !message.trim()) return;

    if (!executeRecaptcha) {
      setStatus("error");
      setError("Security check is still loading. Please try again in a moment.");
      return;
    }

    setStatus("submitting");
    setError(null);
    try {
      // v3 generates a fresh token on every submit, with no checkbox needed.
      const recaptchaToken = await executeRecaptcha("contact_form");

      await submitUserQuery({
        fullName: fullName.trim(),
        email: email.trim(),
        phoneNumber: phone.trim(),
        alternatePhoneNumber: alternatePhone.trim() || undefined,
        message: message.trim(),
        recaptchaToken,
      });
      setStatus("success");
      setFullName("");
      setEmail("");
      setPhone("");
      setAlternatePhone("");
      setMessage("");
    } catch (err) {
      setStatus("error");
      setError(err instanceof Error ? err.message : "Something went wrong. Please try again.");
    }
  };

  const inputClass =
    "w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-[#0F172A] placeholder:text-slate-400 focus:border-[#EB4A2D] focus:outline-none focus:ring-2 focus:ring-[#EB4A2D]/15";
  const labelClass = "mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-slate-500";

  return (
    <section
      id="discuss-campaign"
      className="relative my-4 overflow-hidden bg-[#0B1220] py-20"
    >
      {/* Ambient billboard-light glows */}
      <div
        aria-hidden
        className="pointer-events-none absolute -left-24 -top-24 h-[420px] w-[420px] rounded-full bg-[#EB4A2D]/20 blur-[120px]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-32 -right-16 h-[420px] w-[420px] rounded-full bg-[#1D9BD8]/20 blur-[120px]"
      />

      <div className="relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-start">
        {/* Left: headline + signage-style contact directory */}
        <div>
          <h2 className="font-display max-w-md text-3xl leading-tight text-white sm:text-4xl">
            Let&apos;s discuss your campaign
          </h2>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Every line below goes straight to the team that handles it — pick one and Gmail opens
            ready to send.
          </p>

          <div className="mt-9 border-t border-white/10">
            {CONTACT_EMAILS.map((c) => (
              <a
                key={c.email}
                href={gmailComposeUrl(c.email)}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 border-b border-white/10 py-4 transition-colors hover:bg-white/[0.03]"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-[#EB4A2D] transition-colors group-hover:border-[#EB4A2D]/50 group-hover:bg-[#EB4A2D]/10">
                  <c.icon className="h-4 w-4" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-baseline gap-2">
                    <span className="text-sm font-semibold text-white">{c.label}</span>
                    <span className="hidden text-xs text-slate-500 sm:inline">{c.blurb}</span>
                  </span>
                  <span className="mt-0.5 block truncate text-xs text-slate-400 group-hover:text-slate-200">
                    {c.email}
                  </span>
                </span>
                <ArrowUpRight className="h-4 w-4 shrink-0 text-slate-600 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#EB4A2D]" />
              </a>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-slate-400">
            <a href={`tel:${CONTACT_INFO.phone.replace(/\s+/g, "")}`} className="flex items-center gap-2 hover:text-white">
              <Phone className="h-4 w-4 text-slate-500" />
              {CONTACT_INFO.phone}
            </a>
            <span className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-slate-500" />
              {CONTACT_INFO.address}
            </span>
          </div>

          <div className="mt-8 flex items-center gap-2.5">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-slate-400 transition-colors hover:border-white/30 hover:text-white"
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        {/* Right: message form, mounted like a lit panel against the dark backdrop */}
        <div className="rounded-2xl bg-white p-6 shadow-[0_30px_70px_-20px_rgba(0,0,0,0.55)] sm:p-8">
          <h3 className="text-base font-semibold text-[#0F172A]">Send a message</h3>

          {status === "success" ? (
            <div className="mt-6 flex flex-col items-center gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-5 py-10 text-center">
              <CheckCircle2 className="h-8 w-8 text-emerald-500" />
              <p className="text-sm text-slate-600">
                Thank you, Adroj team will contact you soon.
              </p>
              <button
                onClick={() => setStatus("idle")}
                className="mt-1 text-xs font-semibold text-[#EB4A2D] hover:underline"
              >
                Send another message
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-5 space-y-4">
              <div>
                <label className={labelClass}>Full name *</label>
                <input
                  className={inputClass}
                  placeholder="Enter your full name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className={labelClass}>Email address *</label>
                <input
                  type="email"
                  className={inputClass}
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                  <label className={labelClass}>Phone number *</label>
                  <input
                    type="tel"
                    className={inputClass}
                    placeholder="Enter your phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label className={labelClass}>Alternate phone number</label>
                  <input
                    type="tel"
                    className={inputClass}
                    placeholder="Optional"
                    value={alternatePhone}
                    onChange={(e) => setAlternatePhone(e.target.value)}
                  />
                </div>
              </div>
              <div>
                <label className={labelClass}>Message *</label>
                <textarea
                  className={`${inputClass} min-h-[110px] resize-none`}
                  placeholder="Tell us about your advertising needs..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </div>

              {status === "error" && error && (
                <p className="text-xs text-red-500">{error}</p>
              )}

              <button
                type="submit"
                disabled={status === "submitting"}
                className="flex w-full items-center justify-center gap-2 rounded-full bg-[#EB4A2D] px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-500/20 transition-transform hover:scale-[1.01] disabled:opacity-60"
              >
                {status === "submitting" ? (
                  <>
                    <Loader2 className="h-4 w-4 animate-spin" /> Sending...
                  </>
                ) : (
                  <>
                    Send message <Send className="h-4 w-4" />
                  </>
                )}
              </button>

              <p className="text-center text-[11px] leading-relaxed text-slate-400">
                Protected by reCAPTCHA. Google's{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  Terms of Service
                </a>{" "}
                apply.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <ContactSectionContent />
    </GoogleReCaptchaProvider>
  );
}